import axios from "axios";
import APIs from "@/components/APIInit";
import router from "@/router";
//import { bus } from "@/main";

var vm;
export default {
  methods: {
    getCheckoutFormJson: function (clientId, eventId, quantity, defaultSelect, redirect_url, auto_login) {
      vm = this;
      var eventCollection = "OA_UAT_" + clientId + eventId;
      //bus.$emit("toggleLoader", true);
      axios
        .get(
          `${APIs.googleSoragePath}${eventCollection}/Registration/CheckoutForms.JSON`
        )
        .then((response) => {
          //debugger;
          response.data.RegistrationTypes.forEach((item) => {
            if (item.RegistrationType.toLowerCase() == "attendee") {
              if (defaultSelect) {
                vm.goForRegister(clientId, eventId, item, quantity, redirect_url, auto_login);
              }
              return;
            }
          });
          //bus.$emit("toggleLoader", false);
        })
        .catch(() => {
          //bus.$emit("toggleLoader", false);
        });
    },
    goForRegister(clientId, eventId, registrationType, quantity, redirect_url, auto_login) {
      //debugger;
      //bus.$emit("toggleLoader", true);
      if (!auto_login) {
        auto_login = false;
      }
      let selectedRegistrationTypes = [registrationType];
      let regTypes = new Object();
      let formRegTypes = [];
      for (let item of selectedRegistrationTypes) {
        for (let i = 1; i <= quantity; i++) {
          item["FormLabel"] = `${item.RegistrationType} Registrant ${i}`;
          formRegTypes.push({ ...item });
        }
        regTypes[item.RegistrationTypeId] = quantity;
      }
      let checkoutPice = 0;
      if (selectedRegistrationTypes.length) {
        let headers = {
          "content-type": "application/json",
        };
        let requestData = {
          key: {
            instanceId: "OA_UAT",
            clientId: clientId,
            eventId: eventId,
          },
          data: regTypes,
        };
        axios
          .post(APIs.InitRegisterAttendee, requestData, {
            headers: headers,
          })
          .then((response) => {
            debugger;
            console.log(response);
            //bus.$emit("toggleLoader", false);
            if (response && response.data) {
              if (response.data.status == 0) {
                router.push({
                  name: "Reg3",
                  params: {
                    e: eventId,
                    bundleId: response.data.bundleId,
                    expiry: response.data.expiry,
                    regTypes: formRegTypes,
                    checkoutPice: Number(checkoutPice).toFixed(2),
                    redirect_url: redirect_url,
                    auto_login: auto_login,
                  },
                });
              } else {
                vm.showSnackbar(response.data.msg, "error", "top");
              }
            } else {
              vm.showSnackbar("Something went wrong!", "error", "top");
            }
          })
          .catch((error) => {
            //debugger;
            //bus.$emit("toggleLoader", false);
            vm.showSnackbar("Something went wrong!", "error", "top");
            console.log(error);
          });
      } else {
        //debugger;
        //bus.$emit("toggleLoader", false);
        vm.showSnackbar("Select Atleast One Ticket!", "error", "top");
      }
    },
  }
}